/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, limit: NonNullable<unknown> }} Model_Premium_PoolInputs */

const en_model_premium_pool = /** @type {(inputs: Model_Premium_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Premium credits: ${i?.used} / ${i?.limit} this month`)
};

const id_model_premium_pool = /** @type {(inputs: Model_Premium_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kredit premium: ${i?.used} / ${i?.limit} bulan ini`)
};

/**
* | output |
* | --- |
* | "Premium credits: {used} / {limit} this month" |
*
* @param {Model_Premium_PoolInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_premium_pool = /** @type {((inputs: Model_Premium_PoolInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Premium_PoolInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_premium_pool(inputs)
	return en_model_premium_pool(inputs)
});